import getRenderedFieldName from './getRenderedFieldName';

const prepareServerValidationError = (errors, recipient) => {
    const validationError = {};

    errors.forEach((error) => {
        const fieldName = getRenderedFieldName(error.field, recipient);

        if (fieldName === null) {
            return;
        }

        // The API can report two violations for one field, which shows a single message.
        validationError[fieldName] = [validationError[fieldName], error.message]
            .filter(Boolean)
            .join(' ');
    });

    return validationError;
};

export default prepareServerValidationError;
